import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CustomerAuthProvider } from "./context/CustomerAuthContext";
import Home from "./pages/Home";
import ProductsPage from "./pages/ProductsPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboardNew from "./pages/AdminDashboardNew";
import CartCheckout from "./pages/CartCheckout";
import OrderSuccess from "./pages/OrderSuccess";
import CustomerLogin from "./pages/CustomerLogin";
import AuthCallback from "./pages/AuthCallback";
import CustomerDashboard from "./pages/CustomerDashboard";
import ProductDetailPage from "./pages/ProductDetailPage";
import DiwaliLanding from "./pages/DiwaliLanding";

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id synchronously during render (prevents race conditions)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/diwali" element={<DiwaliLanding />} />
      <Route path="/products" element={<ProductsPage />} />
      <Route path="/product/:productId" element={<ProductDetailPage />} />
      <Route path="/login" element={<CustomerLogin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/my-orders" element={<CustomerDashboard />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboardNew />} />
      <Route path="/cart" element={<CartCheckout />} />
      <Route path="/cart-checkout" element={<CartCheckout />} />
      <Route path="/order-success" element={<OrderSuccess />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CustomerAuthProvider>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </CustomerAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
